import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles

import autoComplete from "@tarekraafat/autocomplete.js";

/**
 * Base css generation and global js logic.
 */

import './tailwind.tokens.css';
import './typography.css';
import './icon.css';
import './layout-builder.css';
import './container.css';
import './slick.css';
import './drupal-override.css';
import './room.css';
import './head.css';
import './footer.css';
import './property.css';
import './map.css';
import './views.css';
import './brand-offer.css';
import './property-offer.css';
import './faq-group.css';
import './filters.css';
import './custom-block.css';
import './mega-menu.css';
import './webform.css';
import './booking.css';
import './modal.css';
import './wellbeing.css';
import './search.css';
import './chat.css';
import './popup.css';

/* AOS Scroll fadein anim init */
AOS.init({
  once: true,
  duration: 500,
  easing: 'ease-in-out',
  offset: 1200,
  disable: true // comment true to turn AOS element fade in scroll to window feature
});

/* Navbar animation */
(function ($, Drupal) {
  Drupal.behaviors.initNavbarAnim = {
    attach: function (context, settings) {
      var didScroll;
      var lastScrollTop = 0;
      var delta = 5;
      var navbar = $('.head__container');
      var navbarHeight = navbar.outerHeight();

      $(window).scroll(function (event) {
        didScroll = true;
      });

      setInterval(function () {
        if (didScroll) {
          var position = $(this).scrollTop();
          /* Make sure they scroll more than delta */
          if (Math.abs(lastScrollTop - position) <= delta) {
            return;
          }

          /* Check if there if its hotels path */
          if ($('html').hasClass('hotels-path')) {
            navbarHeight = 147;
            navbar = $('.header-subpage-container');
          }

          var isBookingWidgetOpen = $('.booking-widget-block').hasClass('active');
          var isSearchOpen = $('html').hasClass('search-active');

          /* If they scrolled down and are past the navbar, add class .nav-up. */
          /* This is necessary so you never see what is "behind" the navbar. */
          if (position > lastScrollTop && position > navbarHeight && !isBookingWidgetOpen && !isSearchOpen) {
            /* Scroll Down */
            navbar.removeClass('nav-down').addClass('nav-up');
            if ($('html').hasClass('hotels-path')) {
              $(".head__container__wrapper").children().removeClass('nav-down').addClass('nav-up');
            }
          } else {
            /* Scroll Up */
            if (position + $(window).height() < $(document).height()) {
              navbar.removeClass('nav-up').addClass('nav-down');
              if ($('html').hasClass('hotels-path')) {
                $(".head__container__wrapper").children().removeClass('nav-up').addClass('nav-down');
              }
            }
          }
          lastScrollTop = position;

          didScroll = false;
        }
      }, 250);


    }
  };
}(global.jQuery, Drupal));

/* Subpage menu */
(function ($, Drupal) {
  Drupal.behaviors.initSubpageMenu = {
    attach: function (context, settings) {
      /* Get url */
      let url = $(location).attr('pathname');

      /* Run js for property pages */
      if (url.includes('/destinations/')) {
        /* get property overview link */
        let link = $('div.property-header__subpages-item:nth-child(2) a').attr('href');
        if (link) {

          let langcode = link.split('/')[1];
          let property = link.split('destinations/')[1].split('/')[0];
          /* Change overview button link dynamically */
          $('div.property-header__subpages-item:first-child a').attr('href', '/' + langcode + '/destinations/' + property);

          /* Set active state for buttons */
          let activeButton = document.querySelector('a[href$="' + url + '"]');

          if (activeButton) {
            activeButton.classList.add('active');
          }

          /* Add class to html tag */
          if (url.split('/').length - 2 >= 3) {
            $('html').addClass('hotels-path')
          }
        }
      }
    }
  };
}(global.jQuery, Drupal));

/* Hamburger opening and closing */
(function ($, Drupal) {
  Drupal.behaviors.initMenuAnim = {
    attach: function (context, settings) {
      $('.hamburger').on('click', (function () {
        /* Set overflow none class to html */
        $('html').toggleClass('mega-menu-active');

        /* get parent */
        let parentHead = $(this).closest('.head');

        /* Animate hamburger */
        $(this).toggleClass('open');

        /* Animate nav bar */
        parentHead.toggleClass('open');

        /* Animate mega menu dropdown */
        parentHead.next().toggleClass('open');

        /* Delay and add animation to mega menu content */
        if (parentHead.hasClass('open')) {
          setTimeout(function () {
            // your code to be executed after 1 second
            $('.mega-menu__container-wrapper').toggleClass('open');
          }, 500);

          if ($(window).width() > 1279) {
            $('.mega-menu-identifier-hotels').addClass('active');
            $('.mega-menu__content-hotels ').addClass('open');
          }
        } else {
          $('.mega-menu__container-wrapper').toggleClass('open');
        }
      }));
    }
  };
}(global.jQuery, Drupal));

/* Main menu */
(function ($, Drupal) {
  Drupal.behaviors.initMegamenu = {
    attach: function (context, settings) {
      var target;

      /* mobile behaviour */
      if (window.innerWidth < 1279) {
        $('.icon-container').on('click', (function () {
          /* get target */
          let targetArray = $(this).prev().attr('class').replace('is-active', '').replace('active', '').split('identifier-');
          target = targetArray[1];

          /* hide mega menu */
          $('.mega-menu__menu').addClass('hide');

          /* show mega menu content */
          $('.mega-menu__content-' + target).removeClass('hide');
          $('.mega-menu__content-' + target).addClass('open');

          /* set level two menu open */
          $('.mega-menu').addClass('mobile-menu-inner-open');
        }));

        /* back button behaviour */
        $('.back-button').on('click', (function () {
          /* hide mega menu */
          $('.mega-menu__menu').removeClass('hide');

          /* hide mega menu content */
          $('.mega-menu__content-' + target).removeClass('open');
          $('.mega-menu__content-' + target).addClass('hide');

          /* set level two menu remove */
          $('.mega-menu').removeClass('mobile-menu-inner-open');
        }));
      }
      /* desktop 1280px behaviour */
      else {
        $("[class*='mega-menu-identifier']").on('mouseenter', (function () {
          /* reset all link */
          $("[class*='mega-menu-identifier']").removeClass('active');

          /* set link to be active */
          $(this).addClass('active');

          /* get target */
          let targetArray = $(this).attr('class').replace('is-active', '').replace('active', '').split('identifier-');
          let target = targetArray[1];

          /* reset all mega menu content on the right */
          $("[class*='mega-menu__content-']").removeClass('open');

          /* show mega menu content on the right */
          $('.mega-menu__content-' + target).addClass('open');
        }));
      }
    }
  };
}(global.jQuery, Drupal));

/* Property gallery */
(function ($, Drupal) {
  Drupal.behaviors.initPropertyGallery = {
    attach: function (context, settings) {
      /* Hide trigger if no gallery */
      let gallery = $('.property-header__gallery .grid-views-container');

      /* Show trigger */
      if (gallery.length >= 1) {
        $('.property-header__gallery-trigger-container').show();
      }

      /* Show lightbox */
      $('.property-header__gallery-trigger-link').on('click', function () {
        $('.property-header__gallery-container').addClass("show-modal");
        $('.property-header__gallery-container .slick-close').css("visibility", "visible");
      });

      /* Close lightbox */
      $('.property-header__gallery-container .slick-close').on('click', function () {
        $('.property-header__gallery-container').removeClass("show-modal");
        $('.property-header__gallery-container .slick-close').css("visibility", "hidden");
      });
    }
  };
}(global.jQuery, Drupal));

/* Property gallery popup */
(function ($, Drupal) {
  Drupal.behaviors.property_gallery_popup = {
    attach: function (context, settings) {

      var parentLightBoxWrapper;
      var openedLightBoxEl;

      $('.property-slider__img-content').on('click', function () {

        // Set parent wrapper 
        parentLightBoxWrapper = $(this);

        // Detach ready to be appended
        var lightboxEl = $(this).next();
        var lightboxElClone = lightboxEl.detach();

        // Set close button
        var lightboxCloseEl = lightboxElClone.find('.property-slider__light-box-close');

        // Show lightbox
        lightboxElClone.appendTo('main.container');

        // Add delay for animation to happen after appending
        setTimeout(
          function () {
            lightboxElClone.addClass("show-modal");
          }, 50);

        lightboxCloseEl.css("visibility", "visible");

        // Set detached lightboxEl
        openedLightBoxEl = lightboxElClone;
      });

      $('.property-slider__light-box-close').on('click', function () {
        openedLightBoxEl.removeClass("show-modal");

        // Add delay for animation to happen after appending
        setTimeout(
          function () {
            // Close lightbox & append back to parent
            openedLightBoxEl.detach();
            openedLightBoxEl.insertAfter(parentLightBoxWrapper);
            openedLightBoxEl.css("visibility", "hidden");
          }, 300);
      });
    }
  };
}(global.jQuery, Drupal));

/* footer webform */
// (function($, Drupal) {
//   Drupal.behaviors.initFooterWebform = {
//     attach: function(context, settings) {
//       /* set webform */
//       let webform = $('.webform_newsandoffer');
//       let parentContainer = $('.footer__top--containter');

//       /* open webform trigger */
//       $('.footer__top--containter--newsandoffers').on('click', function() {
//         parentContainer.toggleClass('active');
//         webform.toggleClass('active');

//         setTimeout(function() {
//           //your code to be executed after 1 second
//           var webformScrollToEl = document.querySelector(".webform_newsandoffer");
//           // smooth scroll to element and align it at the bottom
//           webformScrollToEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
//         }, 100);
//       });

//       /* close webform trigger */
//       $('.webform-section-trigger').on('click', function() {
//         parentContainer.toggleClass('active');
//         webform.toggleClass('active');
//       });
//     }
//   };
// }(global.jQuery, Drupal));

/* booking widget listener */
(function ($, Drupal) {
  Drupal.behaviors.addBookingWidgetListener = {
    attach: function (context, settings) {
      var bookingLeft = $('.booking-widget-container--left');
      var bookingRight = $('.booking-widget-container--right');
      var bookingBlock = $('.booking-widget-block');
      var paneImage = $('.booking-pane');
      var pane1 = $('.booking-pane1');
      var pane2 = $('.booking-pane2');

      var headContainer = $('.head__container');
      var hamburger = $('.head .hamburger ');
      var btnBookNow = $('.head__container-button .booknow');
      var btnClose = $('.booking_widget .closebutton');

      /* open booking widget */
      function openBookingWidget() {
        bookingLeft.addClass('active').css("visibility", "visible");
        bookingBlock.addClass('active').css("visibility", "visible");
        paneImage.addClass('active').css("visibility", "visible");
        pane1.addClass('active').css("visibility", "visible");
        pane2.addClass('active').css("visibility", "visible");
        bookingRight.addClass('active').css("visibility", "visible");

        headContainer.addClass('booking bookingClose');
        hamburger.addClass('displayHide');
        btnBookNow.addClass('displayHide');

        btnBookNow.hide();
        btnClose.show();
        setTimeout(function () {
          btnClose.removeClass('displayHide');
        }, 1000);
      }

      /* close booking widget */
      function closeBookingWidget() {
        bookingLeft.removeClass('active').toggleClass('close').css("visibility", "hidden");
        bookingBlock.removeClass('active').toggleClass('close').css("visibility", "hidden");
        paneImage.removeClass('active').toggleClass('close').css("visibility", "hidden");
        pane1.removeClass('active').toggleClass('close').css("visibility", "hidden");
        bookingRight.toggleClass('active').toggleClass('close').css("visibility", "hidden");
        pane2.removeClass('active').toggleClass('close').css("visibility", "hidden");

        hamburger.removeClass('displayHide');
        btnClose.addClass('displayHide');
        headContainer.removeClass('booking bookingClose');

        btnClose.hide();
        btnBookNow.show();
        setTimeout(function () {
          btnBookNow.removeClass('displayHide');
          bookingLeft.removeClass("close");
          bookingBlock.removeClass("close");
          paneImage.removeClass("close");
          pane1.removeClass("close");
          bookingRight.removeClass("close");
          pane2.removeClass("close");
        }, 75);
      }

      /* open booking widget on click btnbooknow */
      $('.head__container-button .booknow').on('click', function () {
        openBookingWidget();
      });

      /* close booking widget on click btnclose */
      $('.booking_widget .closebutton').on('click', function () {
        closeBookingWidget();
      });

      /* open booking widget on click btn check availabilities */
      $('.check-availability-button').on('click', function () {
        openBookingWidget();
      });
    }
  };
}(global.jQuery, Drupal));

/* add litepicker to webform date fields */
(function ($, Drupal) {
  Drupal.behaviors.particle_litepicker = {
    attach: function (context, settings) {
      /* if datepicker exists, initialise it once */
      $(once('add-litepicker-global', 'input.input-dates-litepicker:not(.input-dates--past)', context)).each(function () {
        var id = $(this).attr('id');
        var parentWrapperId = $(this).closest('.input-wrapper').attr('id');

        new Litepicker({
          element: document.getElementById(id),
          parentEl: document.getElementById(parentWrapperId),
          /* start sunday */
          firstDay: 0,
          /* auto refresh (input) */
          autoRefresh: true,
          /* disable date range */
          singleMode: true,
          /* date format */
          format: 'D MMM YYYY',
          /* set date settings to disable previous day/months */
          minDate: strtotime('now') * 1000,
        });

        /* disable any input, forces user to use datepicker */
        $(this).keypress(function (event) {
          event.preventDefault();
          return false;
        });

        /* disable touch devices input */
        $(this).attr('inputmode', 'none');

      });

      $(once('add-litepicker-global', 'input.input-dates-litepicker.input-dates--past', context)).each(function () {
        var id = $(this).attr('id');
        var parentWrapperId = $(this).closest('.input-wrapper').attr('id');

        new Litepicker({
          element: document.getElementById(id),
          parentEl: document.getElementById(parentWrapperId),
          /* start sunday */
          firstDay: 0,
          /* auto refresh (input) */
          autoRefresh: true,
          /* disable date range */
          singleMode: true,
          /* date format */
          format: 'D MMM YYYY',
          /* set date settings to disable future day/months */
          maxDate: strtotime('now') * 1000,
          /* enable the year and month dropdown for future for better UX */
          /* potential issue: dropdown is not styled */
          // dropdowns: {"minYear":1900,"maxYear":null,"months":true,"years":true}
        });
        /* disable touch devices input */
        $(this).attr('inputmode', 'none');

      });

      /* manually trigger to open litepicker on date field focus */
      $('body').find('input.input-dates-litepicker').focus(function (event) {
        $(this).trigger('click');
        event.preventDefault();
      });

    }
  };
}(global.jQuery, Drupal));

/* add jquery-timepicker to webform time fields, manual init allows us to control the options */
(function ($, Drupal) {
  Drupal.behaviors.particle_timepicker = {
    attach: function (context, settings) {
      /* if time field exists, initialise it once */
      $(once('add-timepicker-global', 'body.input.input-time-timepicker')).each(function () {
        /* init the timepicker with options */
        var inputElId = $(this).attr('id');
        var parentWrapperId = $(this).closest('.input-wrapper').attr('id');
        var timePickerOptions = {
          'appendTo': '#' + parentWrapperId,
          'step': 15,
          'disableTouchKeyboard': true,
          'disableTextInput': true,
          'minTime': '06:30am',
          'maxTime': '09:30pm',
        }
        $('#' + inputElId).timepicker(timePickerOptions);

      });
    }
  };
}(global.jQuery, Drupal));

/* Structured carousel */
(function ($, Drupal) {
  Drupal.behaviors.structured_carousel = {
    attach: function (context, settings) {

      var parentSlick = $('.slick--optionset--structured-carousel');

      // Nested structured carousel on edge hit
      $('.slick--optionset--structured-slides-nested').on('edge', function (event, slick, direction) {

        // parent slick that will shift prev or next
        parentSlick = $(this).closest('.slick--optionset--structured-carousel > .slick-slider');
        // slide prev or next
        if (direction === 'right') {
          parentSlick.slick('slickPrev');
        } else if (direction === 'left') {
          parentSlick.slick('slickNext');
        }

      });

      // using swiped-events.js to listen to swipe events for single slick items
      const SwipeListener = require('swipe-listener');
      var container = document.querySelector('.slick--view--slick--structured-slides-nested > .slide--0');
      var listener = SwipeListener(container);
      if (container) {
        container.addEventListener('swipe', function (e) {
          var directions = e.detail.directions;

          if (directions.left) {
            parentSlick.slick('slickNext');
          }
          if (directions.right) {
            parentSlick.slick('slickPrev');
          }
        });
      }

      parentSlick.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        $('.structured-slides-card-item.open').removeClass('open');
      });

    }
  };
}(global.jQuery, Drupal));

/* Wellbeing activities views */
(function($, Drupal) {
  Drupal.behaviors.wellbeing_activities = {
    attach: function(context, settings) {

      var wellbeingActivitiesCardSimple = $('#views-exposed-form-wellbeing-activities-all-activities ~ .grid-views-container .card-simple');
      
      // Attach listener to card simple
      $(wellbeingActivitiesCardSimple).click(function(event) {
        event.stopImmediatePropagation();

        // Get the target NID
        var nid = $(this).attr('nid');

        // Get the property filter input with the target NID
        var target = $("#views-exposed-form-wellbeing-activities-activities-properties input[value=" + nid + "]");

        // Click property filter
        target.click();

        // Add activate state to the card simple
        if ($(this).hasClass('highlighted')) {
          // Remove class highlighted
          $(this).removeClass('highlighted');
        } else {
          // Add class highlighted
          $(this).addClass('highlighted');
        }
      });

      // Reset WA filtered properties on every WA selection
      $('#views-exposed-form-wellbeing-activities-all-activities label').click(function() {
        $("#views-exposed-form-wellbeing-activities-activities-properties input[value='Reset']").click();
      });
    }
  };
}(global.jQuery, Drupal));

/* Search feature */
(function ($, Drupal) {
  Drupal.behaviors.search = {
    attach: function (context, settings) {

      /* search input on click add class for show hide anim */
      $('.search').on('click', (function () {
        $('html').addClass('search-active');
      }));

      $('.search-container .icon-magnifying-glass-for-search-bar').on('click', (function () {
        $('html').addClass('search-active');
      }));

      $('.search-close').on('click', (function () {
        $('html').removeClass('search-active');
        $('html').removeClass('search-loaded');
        $('html').removeClass('search-empty');
        $('.search').val('');
      }));

      $('.search-container .icon-close-button').on('click', (function () {
        $('html').removeClass('search-active');
        $('html').removeClass('search-loaded');
        $('html').removeClass('search-empty');
        $('.search').val('');
      }));

      /* search input add remove class to show search results or search static content block */
      $(".search").on("input", function() {
        var inputValue = $(this).val();
        if (inputValue == '') {
          $('html').addClass('search-empty');
          $('html').removeClass('search-loaded');
        } else {
          $('html').removeClass('search-empty');
          $('html').addClass('search-loaded');
        }
      });

      if (window.location.href.indexOf("veya") > -1) {
        // The autoComplete.js Engine instance creator
        const autoCompleteJS = new autoComplete({
          data: {
            src: async () => {
              try {
                // Fetch Data Source
                const source = await fetch(
                  "https://" + window.location.hostname + "/search/site"
                );
                const data = await source.json();
                // Returns Fetched data
                return data;
              } catch (error) {
                return error;
              }
            },
            keys: ["title"],
            cache: true,
            // filter: (list) => {
            //   // Filter duplicates
            //   // incase of multiple data keys usage
            //   const filteredResults = Array.from(
            //     new Set(list.map((value) => value.match))
            //   ).map((type) => {
            //     return list.find((value) => value.match === type);
            //   });

            //   return filteredResults;
            // }
          },
          resultsList: {
            element: (list, data) => {
              const info = document.createElement("p");
              if (data.results.length == 0) {
                info.innerHTML = `0 Results Found`;
              }
              list.prepend(info);
            },
            noResults: true,
            // maxResults: 15,
            // tabSelect: true
          },
          resultItem: {
            element: (item, data) => {
              // Modify Results Item Style
              // item.style = "display: flex; justify-content: space-between;";
              // Modify Results Item Content
              var icon = '';
              var title = data.value.title.split(':')[0];

              if (data.value.class == 'property') {
                icon = 'icon-location-marker';
              }
              else if (data.value.class == 'property-offer') {
                icon = 'icon-weddings';
              }
              else if (data.value.class == 'brand-offer') {
                icon = 'icon-weddings';
              }
              else if (data.value.class == 'room') {
                icon = 'icon-property';
              }
              else if (data.value.class == 'wellbeing-activity') {
                icon = 'icon-search-wellbeing-activity';
              }
              item.innerHTML = 
              `
              <a href="${data.value.link}" class="search-item search-item-${data.value.class}">
                <i class="${icon}" aria-hidden='true'><!-- icon --></i>
                ${title}
              </a> 
              `;
            },
            highlight: false
          },
          events: {
            input: {
              focus: () => {
                if (autoCompleteJS.input.value.length) autoCompleteJS.start();
              }
            }
          }
        });
      }
    }
  };
}(global.jQuery, Drupal));

/* Wellbeing quiz */
(function($, Drupal) {
  Drupal.behaviors.wellbeing_quiz = {
    attach: function(context, settings) {

      // initiate active states
      // first active category
      var active_category = 'diet';
      var active_title = $('#edit-diet-title');
      var active_item = $('#edit-diet-q1--wrapper');
      
      $('body').find('.button-intro').on('click', (function() {
        // Add active class to first title
        active_title.addClass('active');
        // Add active class to first item
        active_item.addClass('active');
        // Hide back button
        $('body').find('.prev-btn').hide();
        // Lock the next button
        $('body').find('.next-btn').addClass('lock');

        $(this).parents('.webform-submission-wellbeing-quiz-form').addClass('begin');
      }));

      $('body').find('.webform-submission-wellbeing-quiz-form .input--submit').on('click', (function() {
        // add class to last step
        $('.webform-submission-wellbeing-quiz-form').addClass('ended');
      }));
      
      // Find total category sum
      var total_count = $('.quiz-title').length;
      var current_count = 1;

      // Change html counter
      $('#edit-total-count').html("<p>" + total_count + "</p>");
      $('#edit-current-count').html("<p>" + current_count + "/</p>");
      
      // Add listner to prev button
      $('html:not(.lock)').find('.prev-btn:not(.lock)').on('click', (function(e) {

        if ($('html').hasClass('lock')) {
          return
        } else {
          // e.stopImmediatePropagation();
          $('html').addClass('lock');
          var button = $('body').find('.prev-btn');
          // lock button to prevent multi clicks
          button.addClass('lock');

          var active_item = $('fieldset.active');
          var prev_item = active_item.prevAll('fieldset').first();

          // remove active class from all
          $('fieldset').removeClass('active');

          // ensure item is still in form
          if (prev_item.parents('.webform-submission-wellbeing-quiz-form').length) {
            
            // add active to next form item
            prev_item.addClass('active');
            // find current active form item and remove class
            active_item.removeClass('active');

            // get id of prev item
            var prev_category = prev_item.attr('id').split('-q')[0].replace('edit-', '');
            
            // if its the last time and jumps into next category
            if (!(prev_category.includes(active_category))) {
              // set new active category
              active_category = prev_category;
              // remove active on current title
              $('.quiz-title.active').removeClass('active');
              // add active on next title
              $('#edit-' + prev_category + '-title').addClass('active');
              // change counter
              current_count = current_count - 1;
              $('#edit-current-count').html("<p>" + current_count + "/</p>");

            }

            // remove back button if it's at first quiz item
            if ($('.webform-submission-wellbeing-quiz-form fieldset:first-of-type').hasClass('active')) {
              $('body').find('.prev-btn').hide();
            } else {
              $('body').find('.prev-btn').show();
            }
          }

          
          // render next button lock or unlocked depending on if quiz-item is answered
          if ($('.webform-submission-wellbeing-quiz-form fieldset.active input').is(':checked'))
            button.removeClass('lock');
            
          setTimeout(function() { 
            $('html').removeClass('lock');
          }, 300);
        }
      }));

      // add lock for onclicks
      // Add listner to next button
      $('html:not(.lock)').find('.webform-submission-wellbeing-quiz-form input[type=radio]').on('click', (function(e) {

        if ($('html').hasClass('lock')) {
          return
        } else {
          // e.stopImmediatePropagation();
          $('html').addClass('lock');

          // var button = $('body').find('.next-btn');
          // lock button to prevent multi clicks
          // button.css('pointer-events', 'none');

          var active_item = $('fieldset.active');
          var next_item = $('fieldset.active').next('fieldset').first();

          // remove active class from all
          $('fieldset').removeClass('active');

          // add classes to hide everything when it reaches the submission fieldset
          if (next_item.hasClass('submission-fieldset')) {
            $('.webform-submission-wellbeing-quiz-form').addClass('hide');
          } 
          // ensure item is still in form
          else {
            // add active to next form item
            next_item.addClass('active');
            // find current active form item and remove class
            active_item.removeClass('active');

            // get id of next item
            var next_category = next_item.attr('id').split('-q')[0].replace('edit-', '');
            
            // if its the last time and jumps into next category
            if (!(next_category.includes(active_category))) {
              // set new active category
              active_category = next_category;
              // remove active on current title
              $('.quiz-title.active').removeClass('active');
              // add active on next title
              $('#edit-' + next_category + '-title').addClass('active');
              // change counter
              current_count = current_count + 1;
              $('#edit-current-count').html("<p>" + current_count + "/</p>");
            }

            // remove back button if it's at first quiz item
            if ($('.webform-submission-wellbeing-quiz-form fieldset:first-of-type').hasClass('active')) {
              $('body').find('.prev-btn').hide();
            } else {
              $('body').find('.prev-btn').show();
            }

            // render next button lock or unlocked depending on if quiz-item is answered
            // if ($('.webform-submission-wellbeing-quiz-form fieldset.active input').is(':checked')) {
            //   button.css('pointer-events', 'auto');
            //   button.removeClass('lock');
            // } else {
            //   button.css('pointer-events', 'none');
            //   button.addClass('lock');
            // }
          }

          setTimeout(function() { 
            $('html').removeClass('lock');
          }, 300);
        }
      }));

      // listner for radio buttons to make quiz-item required
      // $('body').find('.webform-submission-wellbeing-quiz-form input').on('click', (function(e) {
      //   if ($('body').find('.next-btn').hasClass('lock'))
      //     $('body').find('.next-btn').removeClass('lock');
      //     $('body').find('.next-btn').css('pointer-events', 'auto');
      // }));
    }
  };
}(global.jQuery, Drupal));

// Export global variables.
export default {
  // Demo only, remove in practice
  GLOBAL_CONSTANT: 'particle',
};
